"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _lodash = _interopRequireDefault(require("lodash"));

var _basic_data_hub_api = _interopRequireDefault(require("./basic_data_hub_api"));

var _constants = require("./lib/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DeploymentsApi =
/*#__PURE__*/
function (_BasicDataHubApi) {
  (0, _inherits2.default)(DeploymentsApi, _BasicDataHubApi);

  function DeploymentsApi() {
    (0, _classCallCheck2.default)(this, DeploymentsApi);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DeploymentsApi).apply(this, arguments));
  }

  (0, _createClass2.default)(DeploymentsApi, [{
    key: "deleteDeployment",
    value: function () {
      var _deleteDeployment = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(deployment) {
        var binding, method, accountId;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getBinding();

              case 2:
                binding = _context.sent;
                method = this._getMethodName('delete');
                accountId = this.accountId;
                return _context.abrupt("return", binding.mutation[method](_objectSpread({
                  entity: _constants.DEPLOYMENT,
                  data: {
                    id: deployment.id
                  }
                }, accountId ? {
                  accountId: accountId
                } : {})));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function deleteDeployment(_x) {
        return _deleteDeployment.apply(this, arguments);
      }

      return deleteDeployment;
    }() // lockDeployment ({id, force}) {
    //     return Promise.try(() => Vue.http.get(`${this.deploymentsLockUrl}/${id}`, _.merge({params : {force}}, this.headers)))
    //         .then(response => response.json());
    // }

  }, {
    key: "getDeploymentById",
    value: function () {
      var _getDeploymentById = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(id, projection) {
        var binding, method, accountId;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getBinding();

              case 2:
                binding = _context2.sent;
                method = this._getMethodName('get');
                accountId = this.accountId;
                return _context2.abrupt("return", binding.query[method](_objectSpread({
                  entity: _constants.DEPLOYMENT,
                  params: {
                    id: id
                  }
                }, accountId ? {
                  accountId: accountId
                } : {}), projection));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getDeploymentById(_x2, _x3) {
        return _getDeploymentById.apply(this, arguments);
      }

      return getDeploymentById;
    }()
  }, {
    key: "getDeployments",
    value: function () {
      var _getDeployments = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(_ref) {
        var _ref$query, query, projection, method, accountId;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _ref$query = _ref.query, query = _ref$query === void 0 ? {} : _ref$query, projection = _ref.projection;
                query = _lodash.default.merge({}, {
                  dateDeactivated: 0
                }, query);
                method = this._getMethodName('list');
                accountId = this.accountId;
                return _context3.abrupt("return", this._getPaginatedList(method, _objectSpread({
                  entity: _constants.DEPLOYMENT,
                  params: {
                    ids: query.id ? _lodash.default.split(query.id, ',') : undefined,
                    queryParams: query
                  }
                }, accountId ? {
                  accountId: accountId
                } : {
                  sandbox: false
                }), projection));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getDeployments(_x4) {
        return _getDeployments.apply(this, arguments);
      }

      return getDeployments;
    }()
  }, {
    key: "getAllDeployments",
    value: function () {
      var _getAllDeployments = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(_ref2) {
        var _ref2$query, query, projection, method, accountId;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _ref2$query = _ref2.query, query = _ref2$query === void 0 ? {} : _ref2$query, projection = _ref2.projection;
                method = this._getMethodName('list');
                accountId = this.accountId;
                return _context4.abrupt("return", this._getPaginatedList(method, _objectSpread({
                  entity: _constants.DEPLOYMENT,
                  params: {
                    ids: query.id ? _lodash.default.split(query.id, ',') : undefined,
                    queryParams: query
                  }
                }, accountId ? {
                  accountId: accountId
                } : {
                  sandbox: false
                }), projection));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getAllDeployments(_x5) {
        return _getAllDeployments.apply(this, arguments);
      }

      return getAllDeployments;
    }()
  }, {
    key: "getActiveDeployments",
    value: function getActiveDeployments(projection) {
      return this.getDeployments({
        projection: projection
      });
    }
  }, {
    key: "getDeploymentsByBotId",
    value: function getDeploymentsByBotId(botId, projection) {
      return this.getDeployments({
        query: {
          botId: botId
        },
        projection: projection
      });
    }
  }, {
    key: "getAllDeploymentsByBotId",
    value: function getAllDeploymentsByBotId(botId, projection) {
      return this.getAllDeployments({
        query: {
          botId: botId
        },
        projection: projection
      });
    }
  }, {
    key: "getActiveDeploymentsByBotId",
    value: function getActiveDeploymentsByBotId(botId, projection) {
      return this.getDeployments({
        query: {
          botId: botId
        },
        projection: projection
      });
    }
  }, {
    key: "getDeploymentsByFlowId",
    value: function getDeploymentsByFlowId(flowId, projection) {
      return this.getDeployments({
        query: {
          flowId: flowId
        },
        projection: projection
      });
    }
  }, {
    key: "getAllDeploymentsByFlowId",
    value: function getAllDeploymentsByFlowId(flowId, projection) {
      return this.getAllDeployments({
        query: {
          flowId: flowId
        },
        projection: projection
      });
    }
  }, {
    key: "getActiveDeploymentsByFlowId",
    value: function getActiveDeploymentsByFlowId(flowId, projection) {
      return this.getDeployments({
        query: {
          flowId: flowId
        },
        projection: projection
      });
    }
  }, {
    key: "saveDeployment",
    value: function () {
      var _saveDeployment = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(deployment) {
        var binding, method, accountId;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.getBinding();

              case 2:
                binding = _context5.sent;
                method = this._getMethodName(deployment.id ? 'update' : 'create');
                accountId = this.accountId;
                return _context5.abrupt("return", binding.mutation[method](_objectSpread({
                  entity: _constants.DEPLOYMENT,
                  data: {
                    id: deployment.id,
                    // is undefined while create action
                    body: deployment
                  }
                }, accountId ? {
                  accountId: accountId
                } : {})));

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function saveDeployment(_x6) {
        return _saveDeployment.apply(this, arguments);
      }

      return saveDeployment;
    }() // unlockDeployment ({id, lockId}) {
    //     return Promise.try(() => Vue.http.delete(`${this.deploymentsLockUrl}/${id}`, _.merge({params : {lockId}}, this.headers)))
    //         .then(response => response.json());
    // }

  }]);
  return DeploymentsApi;
}(_basic_data_hub_api.default);

var _default = DeploymentsApi;
exports.default = _default;